import {
  Authenticate,
  RefreshAuth,
  GetPlayerGames,
  UpdateAttendance,
  GetPlayerGamesVotes,
  SubmitPlayerGameVotes,
  GetMonthlyStats,
  GetGameById,
  GetGameViewById,
  GetPlayerGroups,
  AuthMe,
  ResetPassword,
  ForgotPassword,
  Register,
  UpdatePlayer,
  GetGroupMembers,
  GetGroupMatches,
  GetInfoTeamPlayers,
  GetGroupFacts,
  UpdateGroup,
  CreateGroup,
  CreateGroupPlayer,
  JoinGroup,
  LeaveGroup,
  CreateGame,
  GetGroupById,
  GetPlayersNextGamesAlt,
  GetPlayersPreviousGamesAlt,
  UpdateGame,
  UpdatePlayerGameStats,
  UpdateGameScore,
  GetGameNextStatuses,
  UpdateGameStatus,
  GenerateJoinCode,
  GetPlayerFeaturedGame,
  GetGameVotes,
  GetGroupMembersWithAssists,
  GetGroupMembersWithScores,
  GetGroupMembersWithExpPoints,
  GetPlayersBestGame,
  GetPlayersTotals,
  GetPlayerById,
  GetPlayersGroupsExperience,
  GetPlayerForm,
  GetPlayerMonthlyForm,
  GetLatestGames,
} from "./actions";
import { AddPlayerToGroupByEmail } from "./actions/AddPlayerToGroupByEmail";
import { AddPlayerToGameByEmail } from "./actions/AddPlayerToGameByEmail";
import { RemovePlayerFromGroup } from "./actions/RemovePlayerFromGroup";
import { MakePlayerAdmin } from "./actions/MakePlayerAdmin";

// We should remove "any" from here and use generic Type
const ActionsRegistry: { [key: string]: (params: any) => any } = {
  "/auth/login": Authenticate,
  "/auth/register": Register,
  "/auth/refresh": RefreshAuth,
  "/auth/me": AuthMe,
  "/auth/reset-password": ResetPassword,
  "/auth/forgot-password": ForgotPassword,
  "/players/{id}/games": GetPlayerGames,
  "/players/{id}/games/{gameId}/votes": GetPlayerGamesVotes,
  "/players/{id}/attendance/{attendanceId}": SubmitPlayerGameVotes,
  "/games/{id}": GetGameById,
  "/games/view/{id}": GetGameViewById,
  "/games/{id}/player/{playerId}/attendance": UpdateAttendance,
  "/stats": GetMonthlyStats,
  "/players/{id}/groups": GetPlayerGroups,
  "/players/{id}": UpdatePlayer,
  "/groups/{id}": GetGroupById,
  "/groups/{id}/game": CreateGame,
  "/groups/{groupId}/add-player-to-group-by-email": AddPlayerToGroupByEmail,
  "/next-games": GetPlayersNextGamesAlt,
  "/previous-games": GetPlayersPreviousGamesAlt,
  "/best-game": GetPlayersBestGame,
  "/player-totals": GetPlayersTotals,
  "/player-by-id": GetPlayerById,
  "/players-groups-experience": GetPlayersGroupsExperience,
  "/player-form": GetPlayerForm,
  "/player-monthly-form": GetPlayerMonthlyForm,
  "/group_players_with_total_experience": GetGroupMembers,
  "/players_group_games": GetGroupMatches,
  "/group_players_with_avg_ratings": GetInfoTeamPlayers,
  "/group_facts": GetGroupFacts,
  "/group/{id}": UpdateGroup,
  "/create_group": CreateGroup,
  "/create_group_player": CreateGroupPlayer,
  "/join-group": JoinGroup,
  "/leave-group": LeaveGroup,
  "/remove-player-from-group": RemovePlayerFromGroup,
  "/make-player-admin": MakePlayerAdmin,
  "/games/{gameId}/add-player-to-game-by-email": AddPlayerToGameByEmail,
  "/games/update": UpdateGame,
  "/games/player/stats": UpdatePlayerGameStats,
  "/games/score": UpdateGameScore,
  "/games/next-statuses": GetGameNextStatuses,
  "/games/status": UpdateGameStatus,
  "/group/join-code": GenerateJoinCode,
  "/featured-game": GetPlayerFeaturedGame,
  "/game/votes": GetGameVotes,
  "/get_top_assists_by_group": GetGroupMembersWithAssists,
  "/get_top_scorers_by_group": GetGroupMembersWithScores,
  "/get_top_experience_points_by_group": GetGroupMembersWithExpPoints,
  "/latest-games": GetLatestGames,
};

export default ActionsRegistry;
